export { Deposit } from './Deposit';
export { BottomPlate as DepositBottomPlate, DepositBanner } from './Components';
